export const OPTIX_ACADEMY_LEARNER_READ = 'optixacademylearner:read' as const;
export const OPTIX_ACADEMY_MANAGER_READ = 'optixacademymanager:read' as const;
export const OPTIX_ACADEMY_ADMIN_READ = 'optixacademyadmin:read' as const;
export const SCORM_READ = 'scorm:read' as const;
export const TRAINING_COURSE_READ = 'trainingcourse:read' as const;
export const SKILLS_PROGRAMS_READ = 'skillsprograms:read' as const;
export const QUALIFICATIONS_READ = 'qualifications:read' as const;
export const USER_READ = 'user:read' as const;
export const USER_PROFILE_SUMMARY_READ = 'userprofilesummary:read' as const;
export const LEARNERS_READ = 'learners:read' as const;
export const MODERATORS_READ = 'moderators:read' as const;
export const FACILITATORS_READ = 'facilitators:read' as const;
export const ASSESSORS_READ = 'assessors:read' as const;
export const CERTIFICATE_READ = 'certificate:read' as const;
export const LEARNER_ENROLLMENTS_READ = 'learnersenrollments:read' as const;
export const COHORTS_READ = 'cohorts:read' as const;
export const TRAINME_COURSES_READ = 'trainmecourses:read' as const;
export const TRAINME_COURSES_WRITE = 'trainmecourses:write' as const;
export const TRAINME_OPTIX_ASSESSMENT_READ =
  'trainmeoptixassessment:read' as const;
export const TRAINME_OPTIX_ASSESSMENT_WRITE =
  'trainmeoptixassessment:write' as const;
export const SCORM_TEMPLATE_READ = 'scormtemplate:read' as const;
export const SCORM_TEMPLATE_WRITE = 'scormtemplate:write' as const;
export const TEMPLATES_READ = 'templates:read' as const;
export const TEMPLATES_WRITE = 'templates:write' as const;

export const ROLES = [
  OPTIX_ACADEMY_LEARNER_READ,
  OPTIX_ACADEMY_MANAGER_READ,
  OPTIX_ACADEMY_ADMIN_READ,
  SCORM_READ,
  TRAINING_COURSE_READ,
  SKILLS_PROGRAMS_READ,
  QUALIFICATIONS_READ,
  USER_READ,
  USER_PROFILE_SUMMARY_READ,
  LEARNERS_READ,
  MODERATORS_READ,
  FACILITATORS_READ,
  ASSESSORS_READ,
  CERTIFICATE_READ,
  LEARNER_ENROLLMENTS_READ,
  COHORTS_READ,
  TRAINME_COURSES_READ,
  TRAINME_COURSES_WRITE,
  TRAINME_OPTIX_ASSESSMENT_READ,
  TRAINME_OPTIX_ASSESSMENT_WRITE,
  SCORM_TEMPLATE_READ,
  SCORM_TEMPLATE_WRITE,
  TEMPLATES_READ,
  TEMPLATES_WRITE,
] as const;

export type Role = (typeof ROLES)[number];

export const learnerPortalRoles: Role[] = [OPTIX_ACADEMY_LEARNER_READ];
export const managerPortalRoles: Role[] = [OPTIX_ACADEMY_MANAGER_READ];
export const adminPortalRoles: Role[] = [OPTIX_ACADEMY_ADMIN_READ];
